<div class="quiz">
  <div class="quiz-content">
    <div class="text-content">
      <p class="title">
        {{question.text}}
      </p>
      @if (question.context) {
        <p>
          {{question.context}}
        </p>
      }
    </div>
    @if (question.images | imageForRole:'thumbnail':true; as image) {
      <img class="img-responsive"
        [src]="image | imageUrl:imageTransformations"
        [alt]="image.alt_text"
        (click)="openModal(imageEnlargedModal)"
        >
    }
  </div>
  <multisite-question-credits [contributors]="question.contributors"></multisite-question-credits>
  <form [formGroup]="multipleChoiceForm" role="form">
    <p>
      {{question.help}}
    </p>
    @for (option of question.options; track option; let i = $index) {
      <div class="form-check btn btn-light btn-sm" [ngClass]="{
          'correct-hit':feedbackObject[option.id]?.response_was_correct,
          'correct-miss': feedbackObject[option.id]?.response_was_missing,
          'incorrect':feedbackObject[option.id]?.response_was_correct === false
        }">
        <input class="form-check-input" type="radio" formControlName="options" id="{{option.id}}" [value]="option.id"
          [ngClass]="{
            'correct-hit':feedbackObject[option.id]?.response_was_correct,
            'correct-miss': feedbackObject[option.id]?.response_was_missing,
            'incorrect':feedbackObject[option.id]?.response_was_correct === false
          }">
        @if (feedbackObject[option.id]?.response_was_correct) {
          <div class="answer-icon"><i
          class="fa-solid fa-check"></i></div>
        }
        @if (feedbackObject[option.id]?.response_was_correct === false) {
          <div class="answer-icon"><i
          class="fa-solid fa-xmark"></i></div>
        }
        @if (feedbackObject[option.id]?.response_was_missing) {
          <div class="answer-icon"><i
          class="fa-solid fa-exclamation"></i></div>
        }
        <label class="form-check-label" for="{{option.id}}">
          {{option.value}}
        </label>
      </div>
    }
    <!-- <textarea placeholder="Write your answer here" disabled></textarea> -->
    @if (feedbackText) {
      <p class="multiple-choice-question-feedback my-2 p-3">
        <span class="icon-holder">
          <i class="fa-regular fa-lightbulb"></i>
        </span>
        <span>
          {{feedbackText}}
        </span>
      </p>
    }
    @if (error_message_translation_key) {
      <alert [type]="'info'" class="py-2 w-100">
        <button
          (click)="clearError()"
          type="button" class="close float-right" aria-label="Close"
          >
          <span aria-hidden="true">×</span>
        </button>
        <p *transloco="let t" class="my-3">
          {{ t('error.'+error_message_translation_key) }}<br>
          @if (error_message_translation_key.indexOf('login_required') > -1) {
            <span >
              <a [routerLink]="['/login']">
                <strong>{{ t('common.log_in') }}</strong>
              </a>
            </span>
          }
        </p>
      </alert>
    }
    @if (!feedbackText && (!feedback || (feedback && showTryAgainButtonWithFeedback))) {
      <button class="btn btn-primary my-4" type="submit" [disabled]="!multipleChoiceForm.value.options"
        (click)="doSubmitResponse()">
        @if (loading) {
          <span class="pull-left float-left">
            <multisite-loader-globe-animation-detail [width]="24" [height]="24">
            </multisite-loader-globe-animation-detail>
          </span>
        }
        <span *transloco="let t">
          {{feedback ? t(showTryAgainButtonWithFeedback) : t('common.submit')}}
        </span>
      </button>
    }
  </form>
</div>



<!-- Modal -->

<ng-template #imageEnlargedModal>
  @if (question.images | imageForRole:'base':true; as image) {
    <div class="modal-header">
      <h4 id="dialog-static-name" class="modal-title pull-left">{{image.caption ?? image.alt_text}}</h4>
      <button type="button" class="close btn-close pull-right" aria-label="Close" (click)="modalRef?.hide()">
        <span aria-hidden="true">
          <i class="fa-solid fa-xmark"></i>
        </span>
      </button>
    </div>
    <div class="modal-body">
      <img class="img-responsive"
        [src]="image | imageUrl"
        [alt]="image.alt_text"
        >
    </div>
  }
</ng-template>